import { useAppDispatch } from "@store";
import { setDialogId } from "@store/global-slice";
import { DialogHeader } from "@/shared";

export const Header = () => {
  const dispatch = useAppDispatch();
  const close = () => {
    dispatch(setDialogId({ id: null }));
  };

  return <DialogHeader onClose={close} title="Notification settings" />;
};
